import React from 'react';
import styled from 'styled-components';
import { SurveySectionProps } from '../../types';
import { StatusRow, StatusLabel, ActionButton } from '../../styles';

const SurveyRow = styled(StatusRow)`
  padding: 16px;
  background: white;
  margin: 0 16px 16px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

const ExpiredMessage = styled.p`
  margin: 0;
  max-width: 220px;
  text-align: right;
  font-size: 13px;
  line-height: 1.35;
  color: #666;
`;

const EXPIRED_COPY =
  'No feedback was submitted within 30 days of this shift being completed.';

/** T2-6961: submitted = view-only; unsubmitted = complete only within 30-day window. */
const SurveySection: React.FC<SurveySectionProps> = ({
  hasFeedback,
  canCompleteSurvey = false,
  onCompleteSurvey,
  onViewFeedback,
}) => {
  return (
    <SurveyRow>
      <StatusLabel>Survey Complete?</StatusLabel>
      {hasFeedback ? (
        <ActionButton
          id="talent-view-feedback-button"
          data-testid="talent-view-feedback-button"
          aria-label="View Feedback"
          content-desc="talent-view-feedback-button"
          onClick={onViewFeedback || onCompleteSurvey}
        >
          View Feedback
        </ActionButton>
      ) : canCompleteSurvey ? (
        <ActionButton
          id="talent-complete-survey-button"
          data-testid="talent-complete-survey-button"
          aria-label="Complete Survey"
          content-desc="talent-complete-survey-button"
          onClick={onCompleteSurvey}
        >
          Complete Survey
        </ActionButton>
      ) : (
        <ExpiredMessage data-testid="talent-feedback-expired-message">
          {EXPIRED_COPY}
        </ExpiredMessage>
      )}
    </SurveyRow>
  );
};

export default SurveySection;
